const API_KEY = window.Laravel.google_api_front;
const CALLBACK_NAME = 'gmapsCallback';

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve;
    rejectInitPromise = reject;
});

export default {
    init(key = API_KEY, callback = CALLBACK_NAME) {
        if (initialized) {
            return initPromise;
        }

        initialized = true;
        window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=${callback}`;
        script.onerror = rejectInitPromise;
        document.querySelector('head').appendChild(script);

        return initPromise;
    },
};
